import { render, staticRenderFns } from "./MarketplaceEditCompaniesForm.vue?vue&type=template&id=3987f2a9&scoped=true&"
import script from "./MarketplaceEditCompaniesForm.vue?vue&type=script&lang=js&"
export * from "./MarketplaceEditCompaniesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987f2a9",
  null
  
)

export default component.exports